import { supabase } from '../lib/supabase'

export type EodSignoffPhase = 'office' | 'final'

export interface EodSignoff {
  id: string
  signoff_date: string
  operational_division_id?: string | null
  signed_by?: string | null
  signed_at: string
  phase: EodSignoffPhase
  exception_count: number
  scheduled_count?: number | null
  completed_count?: number | null
  notes?: string | null
  signer?: { first_name?: string; last_name?: string } | null
}

export async function fetchEodSignoffs(
  date: string,
  divisionId?: string | null
): Promise<EodSignoff[]> {
  let q = supabase
    .from('eod_signoffs')
    .select(
      'id, signoff_date, operational_division_id, signed_by, signed_at, phase, exception_count, scheduled_count, completed_count, notes, signer:user_profiles(first_name, last_name)'
    )
    .eq('signoff_date', date)
    .order('signed_at', { ascending: false })

  if (divisionId) {
    q = q.eq('operational_division_id', divisionId)
  }

  const { data, error } = await q
  if (error) throw error
  return (data || []) as EodSignoff[]
}

export async function recordEodSignoff(input: {
  date: string
  divisionId?: string | null
  phase: EodSignoffPhase
  exceptionCount: number
  scheduledCount: number
  completedCount: number
  notes?: string
}): Promise<EodSignoff> {
  const { data, error } = await supabase
    .from('eod_signoffs')
    .insert({
      signoff_date: input.date,
      operational_division_id: input.divisionId || null,
      phase: input.phase,
      exception_count: input.exceptionCount,
      scheduled_count: input.scheduledCount,
      completed_count: input.completedCount,
      notes: input.notes?.trim() || null,
    })
    .select(
      'id, signoff_date, operational_division_id, signed_by, signed_at, phase, exception_count, scheduled_count, completed_count, notes'
    )
    .single()

  if (error) throw error
  return data as EodSignoff
}
